/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Self_Organized_Rounds_DescInputs */



/**
* | output |
* | --- |
* | "Players can form their own table and play a round without an organizer." |
*
* @param {Tfield_Self_Organized_Rounds_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_self_organized_rounds_desc = /** @type {((inputs?: Tfield_Self_Organized_Rounds_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Self_Organized_Rounds_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les joueurs peuvent former leur table et jouer une ronde sans organisateur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los jugadores pueden formar su mesa y jugar una ronda sin organizador.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os jogadores podem formar a própria mesa e jogar uma rodada sem organizador.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I giocatori possono formare il proprio tavolo e giocare un round senza organizzatore.")
	return /** @type {LocalizedString} */ ("Players can form their own table and play a round without an organizer.")
});